import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  en: {
    // Navigation
    home: 'Home',
    fleet: 'Our Fleet',
    about: 'About Us',
    contact: 'Contact',
    admin: 'Admin',
    
    // Hero
    heroTitle: 'Explore Greece',
    heroSubtitle: 'Your Way',
    heroDescription: 'Premium car rental service in Κοκκινόχωμα, Καβάλα. Discover the beauty of Greece with our reliable fleet.',
    bookNow: 'Book Now',
    viewFleet: 'View Fleet',
    
    // Search
    pickupDate: 'Pickup Date',
    returnDate: 'Return Date',
    pickupTime: 'Pickup Time',
    returnTime: 'Return Time',
    pickupLocation: 'Pickup Location',
    search: 'Search Available Cars',
    
    // Fleet
    ourFleet: 'Our Fleet',
    fleetDescription: 'Choose from our selection of quality vehicles',
    perDay: '/day',
    seasonPrice: '(season)',
    seasonLabel: 'High Season',
    discount: 'Discount',
    durationDiscountTitle: 'Book longer, save more!',
    seats: 'seats',
    automatic: 'Automatic',
    manual: 'Manual',
    viewDetails: 'View Details',
    bookThisCar: 'Book This Car',
    
    // Categories
    all: 'All',
    economy: 'Economy',
    comfort: 'Comfort',
    luxury: 'Luxury',
    suv: 'SUV',
    motorcycle: 'Motorcycle',
    
    // Booking
    booking: 'Booking',
    bookingDetails: 'Booking Details',
    customerInfo: 'Customer Information',
    fullName: 'Full Name',
    email: 'Email',
    phone: 'Phone',
    totalDays: 'Total Days',
    totalPrice: 'Total Price',
    proceedToPayment: 'Proceed to Payment',
    bookingConfirmed: 'Booking Confirmed',
    paymentSuccess: 'Payment successful! Your booking is confirmed.',
    
    // Contact
    contactUs: 'Contact Us',
    sendMessage: 'Send Message',
    yourMessage: 'Your Message',
    messageSent: 'Message sent successfully!',
    
    // About
    aboutTitle: 'Universal Rent a Car',
    aboutDescription: 'Your trusted partner for car rental services in Greece.',
    whyChooseUs: 'Why Choose Us',
    bestPrices: 'Best Prices',
    newCars: '24/7 Support',
    freeCancel: 'Free Cancellation',
    
    // Admin
    dashboard: 'Dashboard',
    manageCars: 'Manage Cars',
    manageBookings: 'Bookings',
    messages: 'Messages',
    totalCars: 'Total Cars',
    availableCars: 'Available Cars',
    totalBookings: 'Total Bookings',
    revenue: 'Revenue',
    addCar: 'Add Car',
    editCar: 'Edit Car',
    deleteCar: 'Delete Car',
    save: 'Save',
    cancel: 'Cancel',
    logout: 'Logout',
    login: 'Login',
    username: 'Username',
    password: 'Password',
    
    // Status
    pending: 'Pending',
    confirmed: 'Confirmed',
    paid: 'Paid',
    completed: 'Completed',
    cancelled: 'Cancelled',
    
    // Footer
    address: 'Κοκκινόχωμα, Καβάλα, Greece',
    rights: 'All rights reserved',
    
    // Features
    features: 'Features',
    transmission: 'Transmission',
    fuelType: 'Fuel Type',
    petrol: 'Petrol',
    diesel: 'Diesel',
    electric: 'Electric',
    hybrid: 'Hybrid',
    
    // Documents & Extras
    documents: 'Documents',
    idCard: 'ID Card / Passport',
    license: 'Driver\'s License',
    uploadIdCard: 'Upload ID Card',
    uploadLicense: 'Upload Driver\'s License',
    extras: 'Extras',
    childSeat: 'Child Seat',
    
    // Payment Methods
    paymentMethod: 'Payment Method',
    cardPayment: 'Credit/Debit Card',
    cardPaymentDesc: 'Pay securely with Stripe',
    cashPayment: 'Cash',
    cashPaymentDesc: 'Pay at pickup location',
    bankTransfer: 'Bank Transfer',
    bankTransferDesc: 'Transfer to our bank account',
    confirmBooking: 'Confirm Booking',
  },
  el: {
    // Navigation
    home: 'Αρχική',
    fleet: 'Στόλος',
    about: 'Σχετικά',
    contact: 'Επικοινωνία',
    admin: 'Διαχείριση',
    
    // Hero
    heroTitle: 'Εξερευνήστε την Ελλάδα',
    heroSubtitle: 'Με τον Δικό σας Τρόπο',
    heroDescription: 'Premium υπηρεσία ενοικίασης αυτοκινήτων στο Κοκκινόχωμα. Ανακαλύψτε την ομορφιά της Ελλάδας με τον αξιόπιστο στόλο μας.',
    bookNow: 'Κράτηση Τώρα',
    viewFleet: 'Δείτε τον Στόλο',
    
    // Search
    pickupDate: 'Ημ/νία Παραλαβής',
    returnDate: 'Ημ/νία Επιστροφής',
    pickupTime: 'Ώρα Παραλαβής',
    returnTime: 'Ώρα Επιστροφής',
    pickupLocation: 'Τοποθεσία Παραλαβής',
    search: 'Αναζήτηση Διαθέσιμων',
    
    // Fleet
    ourFleet: 'Ο Στόλος μας',
    fleetDescription: 'Επιλέξτε από τη συλλογή ποιοτικών οχημάτων μας',
    perDay: '/ημέρα',
    seasonPrice: '(σεζόν)',
    seasonLabel: 'Υψηλή Σεζόν',
    discount: 'Έκπτωση',
    durationDiscountTitle: 'Κρατήστε περισσότερο, εξοικονομήστε!',
    seats: 'θέσεις',
    automatic: 'Αυτόματο',
    manual: 'Χειροκίνητο',
    viewDetails: 'Λεπτομέρειες',
    bookThisCar: 'Κράτηση',
    
    // Categories
    all: 'Όλα',
    economy: 'Οικονομικά',
    comfort: 'Comfort',
    luxury: 'Πολυτελή',
    suv: 'SUV',
    motorcycle: 'Μοτοσικλέτα',
    
    // Booking
    booking: 'Κράτηση',
    bookingDetails: 'Στοιχεία Κράτησης',
    customerInfo: 'Στοιχεία Πελάτη',
    fullName: 'Ονοματεπώνυμο',
    email: 'Email',
    phone: 'Τηλέφωνο',
    totalDays: 'Σύνολο Ημερών',
    totalPrice: 'Συνολικό Κόστος',
    proceedToPayment: 'Προχωρήστε στην Πληρωμή',
    bookingConfirmed: 'Η Κράτηση Επιβεβαιώθηκε',
    paymentSuccess: 'Η πληρωμή ολοκληρώθηκε! Η κράτησή σας επιβεβαιώθηκε.',
    
    // Contact
    contactUs: 'Επικοινωνήστε μαζί μας',
    sendMessage: 'Αποστολή Μηνύματος',
    yourMessage: 'Το Μήνυμά σας',
    messageSent: 'Το μήνυμα στάλθηκε επιτυχώς!',
    
    // About
    aboutTitle: 'Universal Rent a Car',
    aboutDescription: 'Ο αξιόπιστος συνεργάτης σας για ενοικίαση αυτοκινήτων στην Ελλάδα.',
    whyChooseUs: 'Γιατί να μας Επιλέξετε',
    bestPrices: 'Καλύτερες Τιμές',
    newCars: 'Υποστήριξη 24/7',
    freeCancel: 'Δωρεάν Ακύρωση',
    
    // Admin
    dashboard: 'Πίνακας Ελέγχου',
    manageCars: 'Διαχ/ση Οχημάτων',
    manageBookings: 'Κρατήσεις',
    messages: 'Μηνύματα',
    totalCars: 'Συνολικά Οχήματα',
    availableCars: 'Διαθέσιμα',
    totalBookings: 'Συνολικές Κρατήσεις',
    revenue: 'Έσοδα',
    addCar: 'Προσθήκη',
    editCar: 'Επεξεργασία',
    deleteCar: 'Διαγραφή',
    save: 'Αποθήκευση',
    cancel: 'Ακύρωση',
    logout: 'Αποσύνδεση',
    login: 'Σύνδεση',
    username: 'Χρήστης',
    password: 'Κωδικός',
    
    // Status
    pending: 'Εκκρεμεί',
    confirmed: 'Επιβεβαιώθηκε',
    paid: 'Πληρώθηκε',
    completed: 'Ολοκληρώθηκε',
    cancelled: 'Ακυρώθηκε',
    
    // Footer
    address: 'Κοκκινόχωμα, Καβάλα, Ελλάδα',
    rights: 'Με επιφύλαξη παντός δικαιώματος',
    
    // Features
    features: 'Χαρακτηριστικά',
    transmission: 'Κιβώτιο',
    fuelType: 'Καύσιμο',
    petrol: 'Βενζίνη',
    diesel: 'Diesel',
    electric: 'Ηλεκτρικό',
    hybrid: 'Υβριδικό',
    
    // Documents & Extras
    documents: 'Έγγραφα',
    idCard: 'Ταυτότητα / Διαβατήριο',
    license: 'Δίπλωμα Οδήγησης',
    uploadIdCard: 'Ανεβάστε Ταυτότητα',
    uploadLicense: 'Ανεβάστε Δίπλωμα',
    extras: 'Επιπλέον',
    childSeat: 'Παιδικό Κάθισμα',
    
    // Payment Methods
    paymentMethod: 'Τρόπος Πληρωμής',
    cardPayment: 'Κάρτα',
    cardPaymentDesc: 'Πληρώστε με ασφάλεια μέσω Stripe',
    cashPayment: 'Μετρητά',
    cashPaymentDesc: 'Πληρωμή κατά την παραλαβή',
    bankTransfer: 'Τραπεζική Μεταφορά',
    bankTransferDesc: 'Μεταφορά στον λογαριασμό μας',
    confirmBooking: 'Επιβεβαίωση Κράτησης',
  },
  de: {
    // Navigation
    home: 'Startseite',
    fleet: 'Fahrzeuge',
    about: 'Über uns',
    contact: 'Kontakt',
    admin: 'Admin',
    
    // Hero
    heroTitle: 'Entdecken Sie Griechenland',
    heroSubtitle: 'Auf Ihre Art',
    heroDescription: 'Premium Autovermietung in Kokkινόχωμα. Entdecken Sie die Schönheit Griechenlands mit unserer zuverlässigen Flotte.',
    bookNow: 'Jetzt Buchen',
    viewFleet: 'Fahrzeuge Ansehen',
    
    // Search
    pickupDate: 'Abholdatum',
    returnDate: 'Rückgabedatum',
    pickupTime: 'Abholzeit',
    returnTime: 'Rückgabezeit',
    pickupLocation: 'Abholort',
    search: 'Verfügbare Suchen',
    
    // Fleet
    ourFleet: 'Unsere Flotte',
    fleetDescription: 'Wählen Sie aus unserer Auswahl an Qualitätsfahrzeugen',
    perDay: '/Tag',
    seasonPrice: '(Saison)',
    seasonLabel: 'Hochsaison',
    discount: 'Rabatt',
    durationDiscountTitle: 'Länger buchen, mehr sparen!',
    seats: 'Sitze',
    automatic: 'Automatik',
    manual: 'Schaltung',
    viewDetails: 'Details',
    bookThisCar: 'Buchen',
    
    // Categories
    all: 'Alle',
    economy: 'Economy',
    comfort: 'Komfort',
    luxury: 'Luxus',
    suv: 'SUV',
    motorcycle: 'Motorrad',
    
    // Booking
    booking: 'Buchung',
    bookingDetails: 'Buchungsdetails',
    customerInfo: 'Kundeninformation',
    fullName: 'Vollständiger Name',
    email: 'E-Mail',
    phone: 'Telefon',
    totalDays: 'Gesamttage',
    totalPrice: 'Gesamtpreis',
    proceedToPayment: 'Zur Zahlung',
    bookingConfirmed: 'Buchung Bestätigt',
    paymentSuccess: 'Zahlung erfolgreich! Ihre Buchung ist bestätigt.',
    
    // Contact
    contactUs: 'Kontaktieren Sie uns',
    sendMessage: 'Nachricht Senden',
    yourMessage: 'Ihre Nachricht',
    messageSent: 'Nachricht erfolgreich gesendet!',
    
    // About
    aboutTitle: 'Universal Rent a Car',
    aboutDescription: 'Ihr zuverlässiger Partner für Autovermietung in Griechenland.',
    whyChooseUs: 'Warum uns Wählen',
    bestPrices: 'Beste Preise',
    newCars: '24/7 Support',
    freeCancel: 'Kostenlose Stornierung',
    
    // Admin
    dashboard: 'Dashboard',
    manageCars: 'Fahrzeuge Verwalten',
    manageBookings: 'Buchungen',
    messages: 'Nachrichten',
    totalCars: 'Gesamtfahrzeuge',
    availableCars: 'Verfügbar',
    totalBookings: 'Gesamtbuchungen',
    revenue: 'Umsatz',
    addCar: 'Hinzufügen',
    editCar: 'Bearbeiten',
    deleteCar: 'Löschen',
    save: 'Speichern',
    cancel: 'Abbrechen',
    logout: 'Abmelden',
    login: 'Anmelden',
    username: 'Benutzer',
    password: 'Passwort',
    
    // Status
    pending: 'Ausstehend',
    confirmed: 'Bestätigt',
    paid: 'Bezahlt',
    completed: 'Abgeschlossen',
    cancelled: 'Storniert',
    
    // Footer
    address: 'Κοκκινόχωμα, Kavala, Griechenland',
    rights: 'Alle Rechte vorbehalten',
    
    // Features
    features: 'Ausstattung',
    transmission: 'Getriebe',
    fuelType: 'Kraftstoff',
    petrol: 'Benzin',
    diesel: 'Diesel',
    electric: 'Elektro',
    hybrid: 'Hybrid',
    
    // Documents & Extras
    documents: 'Dokumente',
    idCard: 'Ausweis / Reisepass',
    license: 'Führerschein',
    uploadIdCard: 'Ausweis hochladen',
    uploadLicense: 'Führerschein hochladen',
    extras: 'Extras',
    childSeat: 'Kindersitz',
    
    // Payment Methods
    paymentMethod: 'Zahlungsmethode',
    cardPayment: 'Kreditkarte',
    cardPaymentDesc: 'Sicher bezahlen mit Stripe',
    cashPayment: 'Bargeld',
    cashPaymentDesc: 'Zahlung bei Abholung',
    bankTransfer: 'Banküberweisung',
    bankTransferDesc: 'Überweisung auf unser Konto',
    confirmBooking: 'Buchung Bestätigen',
  },
  bg: {
    // Navigation
    home: 'Начало',
    fleet: 'Автопарк',
    about: 'За нас',
    contact: 'Контакт',
    admin: 'Админ',
    
    // Hero
    heroTitle: 'Открийте Гърция',
    heroSubtitle: 'По Ваш Начин',
    heroDescription: 'Премиум услуга за коли под наем в Кокиносхома. Открийте красотата на Гърция с нашия надежден автопарк.',
    bookNow: 'Резервирай',
    viewFleet: 'Виж Автопарка',
    
    // Search
    pickupDate: 'Дата на Вземане',
    returnDate: 'Дата на Връщане',
    pickupTime: 'Час на Вземане',
    returnTime: 'Час на Връщане',
    pickupLocation: 'Място на Вземане',
    search: 'Търси Налични Коли',
    
    // Fleet
    ourFleet: 'Нашият Автопарк',
    fleetDescription: 'Изберете от нашата селекция качествени автомобили',
    perDay: '/ден',
    seasonPrice: '(сезон)',
    seasonLabel: 'Висок сезон',
    discount: 'Отстъпка',
    durationDiscountTitle: 'Наемете по-дълго, спестете повече!',
    seats: 'места',
    automatic: 'Автоматик',
    manual: 'Ръчна',
    viewDetails: 'Детайли',
    bookThisCar: 'Резервирай',
    
    // Categories
    all: 'Всички',
    economy: 'Икономични',
    comfort: 'Комфорт',
    luxury: 'Луксозни',
    suv: 'SUV',
    motorcycle: 'Мотоциклет',
    
    // Booking
    booking: 'Резервация',
    bookingDetails: 'Детайли на Резервация',
    customerInfo: 'Информация за Клиента',
    fullName: 'Пълно Име',
    email: 'Имейл',
    phone: 'Телефон',
    totalDays: 'Общо Дни',
    totalPrice: 'Обща Цена',
    proceedToPayment: 'Към Плащане',
    bookingConfirmed: 'Резервацията е Потвърдена',
    paymentSuccess: 'Плащането е успешно! Вашата резервация е потвърдена.',
    
    // Contact
    contactUs: 'Свържете се с нас',
    sendMessage: 'Изпрати Съобщение',
    yourMessage: 'Вашето Съобщение',
    messageSent: 'Съобщението е изпратено успешно!',
    
    // About
    aboutTitle: 'Universal Rent a Car',
    aboutDescription: 'Вашият надежден партньор за коли под наем в Гърция.',
    whyChooseUs: 'Защо Да Ни Изберете',
    bestPrices: 'Най-добри Цени',
    newCars: '24/7 Поддръжка',
    freeCancel: 'Безплатна Отмяна',
    
    // Admin
    dashboard: 'Табло',
    manageCars: 'Управление на Коли',
    manageBookings: 'Резервации',
    messages: 'Съобщения',
    totalCars: 'Общо Коли',
    availableCars: 'Налични',
    totalBookings: 'Общо Резервации',
    revenue: 'Приходи',
    addCar: 'Добави',
    editCar: 'Редактирай',
    deleteCar: 'Изтрий',
    save: 'Запази',
    cancel: 'Отказ',
    logout: 'Изход',
    login: 'Вход',
    username: 'Потребител',
    password: 'Парола',
    
    // Status
    pending: 'Изчакващ',
    confirmed: 'Потвърден',
    paid: 'Платен',
    completed: 'Завършен',
    cancelled: 'Отменен',
    
    // Footer
    address: 'Кокиносхома, Кавала, Гърция',
    rights: 'Всички права запазени',
    
    // Features
    features: 'Характеристики',
    transmission: 'Скоростна Кутия',
    fuelType: 'Гориво',
    petrol: 'Бензин',
    diesel: 'Дизел',
    electric: 'Електрически',
    hybrid: 'Хибрид',
    
    // Documents & Extras
    documents: 'Документи',
    idCard: 'Лична Карта / Паспорт',
    license: 'Шофьорска Книжка',
    uploadIdCard: 'Качи Лична Карта',
    uploadLicense: 'Качи Книжка',
    extras: 'Екстри',
    childSeat: 'Детско Столче',
    
    // Payment Methods
    paymentMethod: 'Начин на Плащане',
    cardPayment: 'Карта',
    cardPaymentDesc: 'Платете сигурно чрез Stripe',
    cashPayment: 'В брой',
    cashPaymentDesc: 'Плащане при получаване',
    bankTransfer: 'Банков Превод',
    bankTransferDesc: 'Превод по нашата сметка',
    confirmBooking: 'Потвърди Резервация',
  },
  tr: {
    // Navigation
    home: 'Ana Sayfa',
    fleet: 'Araç Filosu',
    about: 'Hakkımızda',
    contact: 'İletişim',
    admin: 'Yönetim',
    
    // Hero
    heroTitle: 'Yunanistan\'ı Keşfedin',
    heroSubtitle: 'Kendi Yolunuzda',
    heroDescription: 'Kokkινόχωμα\'da premium araç kiralama hizmeti. Güvenilir filomuzla Yunanistan\'ın güzelliğini keşfedin.',
    bookNow: 'Şimdi Rezerve Et',
    viewFleet: 'Filoyu Gör',
    
    // Search
    pickupDate: 'Alış Tarihi',
    returnDate: 'İade Tarihi',
    pickupTime: 'Alış Saati',
    returnTime: 'İade Saati',
    pickupLocation: 'Alış Yeri',
    search: 'Müsait Araç Ara',
    
    // Fleet
    ourFleet: 'Araç Filomuz',
    fleetDescription: 'Kaliteli araç seçeneklerimizden birini seçin',
    perDay: '/gün',
    seasonPrice: '(sezon)',
    seasonLabel: 'Yüksek Sezon',
    discount: 'İndirim',
    durationDiscountTitle: 'Daha uzun kiralayın, daha çok tasarruf edin!',
    seats: 'koltuk',
    automatic: 'Otomatik',
    manual: 'Manuel',
    viewDetails: 'Detaylar',
    bookThisCar: 'Rezerve Et',
    
    // Categories
    all: 'Tümü',
    economy: 'Ekonomik',
    comfort: 'Konfor',
    luxury: 'Lüks',
    suv: 'SUV',
    motorcycle: 'Motosiklet',
    
    // Booking
    booking: 'Rezervasyon',
    bookingDetails: 'Rezervasyon Detayları',
    customerInfo: 'Müşteri Bilgileri',
    fullName: 'Ad Soyad',
    email: 'E-posta',
    phone: 'Telefon',
    totalDays: 'Toplam Gün',
    totalPrice: 'Toplam Fiyat',
    proceedToPayment: 'Ödemeye Geç',
    bookingConfirmed: 'Rezervasyon Onaylandı',
    paymentSuccess: 'Ödeme başarılı! Rezervasyonunuz onaylandı.',
    
    // Contact
    contactUs: 'Bize Ulaşın',
    sendMessage: 'Mesaj Gönder',
    yourMessage: 'Mesajınız',
    messageSent: 'Mesaj başarıyla gönderildi!',
    
    // About
    aboutTitle: 'Universal Rent a Car',
    aboutDescription: 'Yunanistan\'da araç kiralama için güvenilir ortağınız.',
    whyChooseUs: 'Neden Bizi Seçmelisiniz',
    bestPrices: 'En İyi Fiyatlar',
    newCars: '7/24 Destek',
    freeCancel: 'Ücretsiz İptal',
    
    // Admin
    dashboard: 'Panel',
    manageCars: 'Araç Yönetimi',
    manageBookings: 'Rezervasyonlar',
    messages: 'Mesajlar',
    totalCars: 'Toplam Araç',
    availableCars: 'Müsait',
    totalBookings: 'Toplam Rezervasyon',
    revenue: 'Gelir',
    addCar: 'Ekle',
    editCar: 'Düzenle',
    deleteCar: 'Sil',
    save: 'Kaydet',
    cancel: 'İptal',
    logout: 'Çıkış',
    login: 'Giriş',
    username: 'Kullanıcı',
    password: 'Şifre',
    
    // Status
    pending: 'Beklemede',
    confirmed: 'Onaylandı',
    paid: 'Ödendi',
    completed: 'Tamamlandı',
    cancelled: 'İptal Edildi',
    
    // Footer
    address: 'Κοκκινόχωμα, Kavala, Yunanistan',
    rights: 'Tüm hakları saklıdır',
    
    // Features
    features: 'Özellikler',
    transmission: 'Şanzıman',
    fuelType: 'Yakıt Tipi',
    petrol: 'Benzin',
    diesel: 'Dizel',
    electric: 'Elektrik',
    hybrid: 'Hibrit',
    
    // Documents & Extras
    documents: 'Belgeler',
    idCard: 'Kimlik / Pasaport',
    license: 'Ehliyet',
    uploadIdCard: 'Kimlik Yükle',
    uploadLicense: 'Ehliyet Yükle',
    extras: 'Ekstralar',
    childSeat: 'Çocuk Koltuğu',
    
    // Payment Methods
    paymentMethod: 'Ödeme Yöntemi',
    cardPayment: 'Kredi Kartı',
    cardPaymentDesc: 'Stripe ile güvenli ödeme',
    cashPayment: 'Nakit',
    cashPaymentDesc: 'Teslim alırken ödeme',
    bankTransfer: 'Banka Havalesi',
    bankTransferDesc: 'Hesabımıza havale',
    confirmBooking: 'Rezervasyonu Onayla',
  },
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('language') || 'en';
    }
    return 'en';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations['en'][key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
